import React, { useState } from "react";
import "./JapaneseLearningContent.css";
import "./LearningContent.css";
import FloatIcon from "../FloatIcons/FloatIcons";
import Modal from "react-bootstrap/Modal";
import { GrFormClose } from "react-icons/gr";
import Carousel from "nuka-carousel";
import CardData from "../../data/JapaneseLearning.json";
import { BiSkipNextCircle, BiSkipPreviousCircle } from "react-icons/bi";
function JapaneseLearningContent() {
  const [show, setShow] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [pathOne, setPathOne] = useState();
  const [pathTwo, setPathTwo] = useState();
  const [cardId, setCardId] = useState();
  return (
    <>
      {/* Float Icon Start */}
      <div className="floatIconsContainer">
        <FloatIcon />
      </div>
      {/* Float Icon End */}
      {/* Banner Start */}
      <div className="main-banner">
        <img
          src="/images/Learnings/OfferingsBanner.png"
          alt="Banner"
          className="LearningBanner"
        />
        <h2 id="ourLeadBannerText">
          Japanese Language and Culture Learnings Offered
        </h2>
        {/* <Floaticons /> */}
      </div>
      {/* Banner End */}
      {/* Courses Offered Start */}
      <div className="coursesOfferedContainer">
        {/* Heading Start */}
        <div className="coursesOfferedHeadingSection">
          <h3 className="coursesOfferedHeadingText">Courses Offered</h3>
          <div className="coursesOfferedHeadingSectionRight">
            <h4 className="coursesOfferedHeadingTextRight">Japanese &nbsp;</h4>
            <span className="coursesOfferedHeadingImgRight headerDropdown">
              <img
                src="/images/Learnings/Japanese.png"
                alt="Map"
                className="coursesOfferedHeadingImgRight"
              ></img>
            </span>
          </div>
        </div>
        {/* Heading End */}
        <div style={{ borderTop: "1px solid black" }}>&nbsp;</div>
        <p className="coursesOfferedSubHeading">
          Welcome to our foreign language learning program ! Embrace a journey
          of your choice for cultural enrichment and linguistic mastery. Happy
          Learning !<br />
          L&TT brings to you an opportunity to learn the language and culture
          aspects for Japanese
        </p>
        {/* Cards Start */}
        <div className="offeringCardContainer">
          {CardData.map((item) => {
            return (
              <>
                <div
                  className="offeringCard"
                  onClick={() => {
                    setShow(true);
                    setPathOne(item.ModalBodyInfographics);
                    setCardId(item.id);
                    setPathTwo(item.ModalBodyInfographicsTwo);
                  }}
                >
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/Learnings/newBg1.png"
                    }
                    alt=""
                    className="OfferingsCardBackground"
                  />
                  <div className="offeringCardContent">
                    <div className="offeringCardHeading">
                      <img
                        src={item.headingIconSrc}
                        alt="Icon"
                        className="offeringCardHeadingIcon"
                      />
                      <div className="offeringCardHeadingRight">
                        <p className="offeringCardHeadingRightText">
                          <img
                            src="/images/Learnings/Icon material-timerNew.png"
                            alt="TimerIcon"
                            className="offeringCardHeadingRightIcon"
                          />
                          {item.headingRightText}
                        </p>
                      </div>
                    </div>
                    <p className="offeringCardName">{item.cardName}</p>
                    <p className="offeringCardDetails">{item.cardDetails}</p>
                    <p className="offeringCardDetails">{item.cardDetailsTwo}</p>
                    <div className="offeringCardFooter">
                      View learning Journey
                    </div>
                  </div>
                  {/* Heading */}
                </div>
              </>
            );
          })}
          {cardId == 1 || cardId == 2 ? (
            <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
              <div className="ModalContainerJapanese">
                <div className="modalHeadingSection">
                  <p className="modalHeadingText">Learning Journey</p>
                  <div
                    onClick={() => setShow(false)}
                    className="modalHeadingCloseButton"
                  >
                    <GrFormClose />
                  </div>
                </div>
                <div className="modalBodyInfoContainerOne">
                  <div className="modalBodyInfoContainerDuration">
                    <p className="durationTextRight">
                      <img
                        src="/images/Learnings/Icon material-timerNew.png"
                        alt="TimerIcon"
                        className="offeringCardHeadingRightIcon"
                      />
                      {cardId == 1
                        ? "60Hrs Self Learning Course"
                        : "80Hrs VILT Course"}
                    </p>
                  </div>
                  {cardId == 1 ? (
                    <div className="modalBodyInfoContainerObjective">
                      <p>Objective: </p>
                      To enable the participants to speak and understand the
                      very basic level of day-to-day work-related conversations
                      in the Japanese Language.
                    </div>
                  ) : (
                    <div className="modalBodyInfoContainerObjective">
                      <p>Objective: </p>
                      To enable the participants identified to travel to Japan
                      have an understanding of Japanese basic day-to day and
                      real life scenarios oriented conversational skills.
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          ) : (
            <Modal
              show={show}
              onHide={() => setShow(false)}
              size="xl"
              centered
              aria-labelledby="contained-modal-title-vcenter"
            >
              <div className="ModalContainerJapanese">
                <div className="modalHeadingSection">
                  <p className="modalHeadingText">Learning Journey</p>
                  <div
                    onClick={() => setShow(false)}
                    className="modalHeadingCloseButton"
                  >
                    <GrFormClose />
                  </div>
                </div>
                <div className="modalBodyInfoContainer">
                  {cardId == 0 ? (
                    <Carousel
                      renderCenterLeftControls={({ previousSlide }) => (
                        <button
                          className="modalCarouseArrowLeft"
                          onClick={previousSlide}
                        >
                          <BiSkipPreviousCircle />
                        </button>
                      )}
                      renderCenterRightControls={({ nextSlide }) => (
                        <button
                          className="modalCarouseArrowRight"
                          onClick={nextSlide}
                        >
                          <BiSkipNextCircle />
                        </button>
                      )}
                    >
                      <div className="modalBodyInfographicsOneContainer">
                        <img
                          src={pathOne}
                          alt="Infographics"
                          className="modalBodyInfographicsOne"
                        />
                      </div>
                      <div className="modalBodyInfographicsOneContainer">
                        <img
                          src={pathTwo}
                          alt="Infographics"
                          className="modalBodyInfographicsOne"
                        />
                      </div>
                    </Carousel>
                  ) : cardId == 3 || cardId == 4 || cardId == 6 ? (
                    <div className="modalBodyInfographicsContainer">
                      <img
                        src={pathOne}
                        alt="Infographics"
                        className="modalBodyInfographics"
                      />
                    </div>
                  ) : cardId == 5 ? (
                    <div className="modalBodyInfographicsContainer">
                      "Coming Soon"
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Modal>
          )}
        </div>
        {/* Cards End */}
      </div>
      {/* Courses Offered End */}
      {/* Enablers of LKM Start */}
      <div className="enablersContainer">
        <h3 className="enblersHeading">Enablers of L&TT</h3>
        <div className="enablersGridContainer">
          {/* Left */}
          <div className="enablersGridContentOne">
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                Hand Writing Competition
              </p>
            </div>
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                Japanese Language Events
              </p>
            </div>
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                Weekly Good to know Facts
              </p>
            </div>
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                Accenture Language Program - Team channel for native connects
              </p>
            </div>
          </div>
          <div className="enablersGridContentTwo">
            <img
              src="/images/Learnings/Enablers of LKM infographics.png"
              alt="Infographics"
              className="enablersCenterImg"
            />
          </div>
          {/* Right */}
          <div className="enablersGridContentThree">
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                VILT + Blended Learning Sessions
              </p>
            </div>
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                Conversation connects sessions with Natives
              </p>
            </div>
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                Learning Boards offerings flexible learning
              </p>
            </div>
            <div className="enablersGridContentList">
              <img
                src="/images/Learnings/Polygon 70.png"
                alt="Icon"
                className="enablersGridContentListIcon"
              />
              <p className="enablersGridContentListText">
                Listening practice through audio & video
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Enablers of LKM End */}
      {/* Certification Section Start */}
      <div className="certificationSection">
        <h3 className="certificationHeading">Certification</h3>
        <div className="benefitsSection">
          <div className="certificationCardsContainer">
            <div className="certificationCards">
              <img
                src="/images/Learnings/1.png"
                alt="Banner"
                className="certificationCardIcon"
              />
              <p className="certificationCardText">
                Flairs / Badges and internal certifications upon completion of
                necessary assessments
              </p>
            </div>
            <div className="certificationCards">
              <img
                src="/images/Learnings/2.png"
                alt="Banner"
                className="certificationCardIcon"
              />
              <p className="certificationCardText">
                Internal & External Certification as required basis the level of
                learning
              </p>
            </div>
            <div className="certificationCards">
              <img
                src="/images/Learnings/3.png"
                alt="Banner"
                className="certificationCardIcon"
              />
              <p className="certificationCardText">
                Weekly connect with Trainer | SMEs for doubt clearing
              </p>
            </div>
            <div className="certificationCards">
              <img
                src="/images/Learnings/4.png"
                alt="Banner"
                className="certificationCardIcon"
              />
              <p className="certificationCardText">
                Prep sessions for Internal & External Assessments
              </p>
            </div>
            <div className="certificationCards">
              <img
                src="/images/Learnings/5.png"
                alt="Banner"
                className="certificationCardIcon"
              />
              <p className="certificationCardText">
                Multiple attempts to clear the internal assessment
              </p>
            </div>
            <div className="certificationCards">
              <img
                src="/images/Learnings/6.png"
                alt="Icon"
                className="certificationCardIcon"
              />
              <p className="certificationCardText">
                Reimbursement of external certification cost (Only if the
                participant clears the external certification examination)
              </p>
            </div>
          </div>
          <div className="benefitsSectionContent">
            <div className="benefitsHeadingSection">
              <div className="benefitsHeadingIconsLeft">
                <img
                  src="/images/Learnings/Group 187883.png"
                  alt="Banner"
                  className="benefitsHeadingIconsImg"
                />
              </div>
              <div className="benefitsHeadingIconsRight">
                <img
                  src="/images/Learnings/Group 187885.png"
                  alt="Banner"
                  className="benefitsHeadingIconsImg"
                />
              </div>
              <h3 className="benefitsHeading">Benefits</h3>
            </div>
            <div className="benefitsBodySection">
              <p className="benefitsBodySectionText">
                Batch flexibility{" "}
                <img
                  src="/images/Learnings/Group 188369.png"
                  alt="Icon"
                  className="benefitsBodySectionTextImg"
                />
                Weekly doubts clearing session
              </p>
              <p className="benefitsBodySectionText">
                Dashboard for tracking and monitoring the training progress to
                the language PoCs{" "}
                <img
                  src="/images/Learnings/Group 188369.png"
                  alt="Icon"
                  className="benefitsBodySectionTextImg"
                />
                Bridge batches
              </p>
              <p className="benefitsBodySectionText">
                Batch timings as per the account's requirement{" "}
                <img
                  src="/images/Learnings/Group 188369.png"
                  alt="Icon"
                  className="benefitsBodySectionTextImg"
                />
                Session recordings available
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Certification Section End */}
    </>
  );
}

export default JapaneseLearningContent;
